import Basic from "./basic";
import Advanced from "./advanced";
import Expert from "./expert";

const __surveyjs_internal_configs_hash = true;
export { Basic, Advanced, Expert, __surveyjs_internal_configs_hash };
export default { Basic, Advanced, Expert, __surveyjs_internal_configs_hash };